import React from 'react';

// import logo from '@assets/imgs/PwC_logo_mono_outline_white_rgb.jpg';
// import logo from '@assets/imgs/PwC_Outline_Logo_White.png';
import logo_dark from '@assets/imgs/Pwc_Logo_Dark_New_removebg.png';
import logo_light from '@assets/imgs/Pwc_Logo_Light_New_removebg.png';

// import '@style/components/logo.scss';
import '../../styles/components/logo.scss';
import classnames from 'classnames';
import useTheme from '@hooks/useTheme';

function Logo(props) {
  const { wrappercClassName, imgClassName } = props;
  const wrapperClasses = classnames('logo-wrapper', wrappercClassName);
  const imgClasses = classnames('logo', imgClassName);
  const { theme } = useTheme();
  const logo = theme === 'dark' ? logo_dark : logo_light;
  return (
    <div className={wrapperClasses}>
      <img className={imgClasses} src={logo} alt="" />
    </div>
  );
}

export default Logo;
